import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  loadingSubject = new Subject<any>();
  constructor() { }

  show() {
    this.setStatus({ show: true });
  }
  hide(err?: any) {
    this.setStatus({
      show: false
    });
  }
 private setStatus(message: any) {
    this.loadingSubject.next(message);
  }

  getStatus(): Observable<any> {
    return this.loadingSubject.asObservable();
  }

}